<div class="flex flex-col">
  <mat-label class="flex flex-row items-center gap-2">
    {{ label | translate }}
    <span *ngIf="required && label">*</span>
  </mat-label>
  <mat-form-field class="w-full" [ngClass]="{ 'mat-form-field-invalid': control?.invalid && control?.touched }">
    <mat-select
      [value]="value"
      (selectionChange)="onSelectChange($event.value)"
      [disabled]="isDisabled">
      <mat-option *ngFor="let option of timeframeOptions; trackBy: trackByOptionId" [value]="option.id">
        <ng-container *ngIf="(option.name | timeframeOptionParts) as parts">
          <ng-container *ngIf="parts.monthTranslationKey as monthKey; else justKey">
            {{ parts.key | translate: { month: (monthKey | translate) } }}
          </ng-container>
          <ng-template #justKey>{{ parts.key | translate }}</ng-template>
        </ng-container>
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-error flowValidationErrors *ngIf="control?.invalid && control?.touched"></mat-error>
</div>
